import actions from './actions';

const {
  GET_QWIK_BALANCE_BEGIN,
  GET_QWIK_BALANCE_SUCCESS,
  GET_QWIK_BALANCE_ERR,
  GET_QWIK_MERCHANTS_BEGIN,
  GET_QWIK_MERCHANTS_SUCCESS,
  GET_QWIK_MERCHANTS_ERR,
  GET_QWIK_PRODUCTS_BEGIN,
  GET_QWIK_PRODUCTS_SUCCESS,
  GET_QWIK_PRODUCTS_ERR,
  UPLOAD_QWIK_PRODUCTS_FILE_BEGIN,
  UPLOAD_QWIK_PRODUCTS_FILE_SUCCESS,
  UPLOAD_QWIK_PRODUCTS_FILE_ERR,
} = actions;

const initState = {
  loadingGetQwikBalance: false,
  errorGetQwikBalance: null,
  balance: 0,

  loadingGetQwikMerchants: false,
  errorGetQwikMerchants: null,
  merchants: [],

  loadingGetQwikProducts: false,
  errorGetQwikProducts: null,
  products: [],

  loadingUploadQwikProductsFile: false,
  errorUploadQwikProductsFile: null,
};

/**
 *
 * @todo impure state mutation/explaination
 */
const qwikReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_QWIK_MERCHANTS_BEGIN:
      return {
        ...state,
        loadingGetQwikMerchants: true,
        errorGetQwikMerchants: null,
      };
    case GET_QWIK_MERCHANTS_SUCCESS:
      return {
        ...state,
        merchants: data,
        loadingGetQwikMerchants: false,
        errorGetQwikMerchants: null,
      };
    case GET_QWIK_MERCHANTS_ERR:
      return {
        ...state,
        loadingGetQwikMerchants: false,
        errorGetQwikMerchants: err,
      };

    case GET_QWIK_BALANCE_BEGIN:
      return {
        ...state,
        balance: 0,
        loadingGetQwikBalance: true,
        errorGetQwikBalance: null,
      };
    case GET_QWIK_BALANCE_SUCCESS:
      return {
        ...state,
        balance: data,
        loadingGetQwikBalance: false,
        errorGetQwikBalance: null,
      };
    case GET_QWIK_BALANCE_ERR:
      return {
        ...state,
        loadingGetQwikBalance: false,
        errorGetQwikBalance: err,
      };

    case GET_QWIK_PRODUCTS_BEGIN:
      return {
        ...state,
        loadingGetQwikProducts: true,
        errorGetQwikProducts: null,
      };
    case GET_QWIK_PRODUCTS_SUCCESS:
      return {
        ...state,
        products: data,
        loadingGetQwikProducts: false,
        errorGetQwikProducts: null,
      };
    case GET_QWIK_PRODUCTS_ERR:
      return {
        ...state,
        loadingGetQwikProducts: false,
        errorGetQwikProducts: err,
      };

    case UPLOAD_QWIK_PRODUCTS_FILE_BEGIN:
      return {
        ...state,
        loadingUploadQwikProductsFile: true,
        errorUploadQwikProductsFile: null,
      };
    case UPLOAD_QWIK_PRODUCTS_FILE_SUCCESS:
      return {
        ...state,
        loadingUploadQwikProductsFile: false,
        errorUploadQwikProductsFile: null,
      };
    case UPLOAD_QWIK_PRODUCTS_FILE_ERR:
      return {
        ...state,
        loadingUploadQwikProductsFile: false,
        errorUploadQwikProductsFile: err,
      };
    default:
      return state;
  }
};
export { qwikReducer };
